// extracted by mini-css-extract-plugin
export default {"container":"orders-table_container__vHSsN","row":"orders-table_row__EJ8+e","hasTroubleRow":"orders-table_hasTroubleRow__JE82K"};